import React from 'react';
import SelectCommon from '../Select/SelectCommon';
import { Switch, Space, Col } from 'antd';
import { ButtonCommon } from '../Button/ButtonCommon';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { Circle, GlobeHemisphereEast, UploadSimple, XCircle } from '@phosphor-icons/react';
import { ToolbarProductProps } from 'types';
import ToolbarLayout from './ToolbarLayout';
import ConfirmationModal from '../Modal/ConfirmationModal';
import { ReplaceVersionModal } from '..';

const ToolbarProduct: React.FC<ToolbarProductProps> = ({
  isActive,
  setIsActive,
  checkInactive,
  isEdit,
  isDetail = false,
  barcode,
  nameProduct = '',
  isLoading,
  onSaveDraft,
  onCancel,
  version,
  setVersion,
  setCheckUpdateVersion,
  onReplaceVersion,
  checkUpdate,
  listVersion,
  choiceVersion,
  onPublish,
  onActive,
  onInactive,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenReplaceVersion, setIsOpenReplaceVersion] = React.useState(false);
  const onChange = (checked: boolean) => {
    if (!checked) {
      setIsOpenReplaceVersion(true);
    } else if (onActive && checked) {
      onActive(checked);
      setIsActive(checked);
    }
  };
  const onCancelCick = () => {
    setIsOpen(true);
  };
  const onClose = () => {
    setIsOpen(false);
  };
  React.useEffect(() => {
    const isActiveVersion = listVersion?.find((item) => item?.version === version)?.isActive as boolean;
    setIsActive(isActiveVersion);
  }, [version]);
  function handleReplaceVersion(selectedVersion: string | null): void {
    if (onReplaceVersion && selectedVersion) {
      const versionReplace = listVersion?.find((item) => item?.id === selectedVersion)?.version;
      onReplaceVersion(selectedVersion || '', versionReplace || 1);
    } else {
      onActive?.(false);
    }
  }

  return (
    <ToolbarLayout
      left={
        <Space align='center' className='gap-4 2xl:gap-6 flex-wrap'>
          <Space size='small' align='center' className='text-sm'>
            <p className='text-[var(--textBlack56)]'>Mã:</p>
            <span className='font-medium'>{barcode}</span>
          </Space>

          {/* <img src={iconWarnnig} width={18} height={18} alt='icon warning' /> */}

          <Space size='small' align='center' className='text-sm'>
            <p className='text-[var(--textBlack56)]'>Tên:</p>
            <span className='font-medium'>{nameProduct}</span>
          </Space>
          <div className='w-[120px]'>
            <SelectCommon
              variant='filled'
              statusSelect={isDetail ? 'default' : 'disabled'}
              value={`Ver ${version?.toFixed(1)}`}
              className={`${!isDetail || checkInactive ? 'pointer-events-none opacity-50' : ''} `}
              onChange={(value) => {
                setVersion?.(listVersion?.find((item) => item?.id === value)?.version as number);
                choiceVersion?.(value);
              }}
              options={listVersion?.map((version) => ({
                label: `Ver ${version?.version?.toFixed(1)}`,
                value: version?.id,
              }))}
            />
          </div>
          {checkInactive ? (
            <div className='flex-center text-sm rounded-lg h-[30px] xl:h-[32px] text-white px-3 bg-[var(--sematicErrorColor500)]'>
              Ngừng kinh doanh
            </div>
          ) : (
            <>
              {isDetail &&
                !isEdit &&
                (isActive ? (
                  <div className='flex-center text-sm rounded-lg h-[30px] xl:h-[32px] text-white px-3 bg-[var(--sematicSuccessColor500)]'>
                    Đang hoạt động
                  </div>
                ) : (
                  <div className='flex-center text-sm rounded-lg h-[30px] xl:h-[32px] text-white px-3 bg-[var(--primaryColor500)]'>
                    Không kích hoạt
                  </div>
                ))}
            </>
          )}

          <ButtonCommon
            color='basic'
            isDisabled={!(isDetail && !isEdit) || checkInactive}
            fullWidth
            radius='rounded'
            size='md'
            className={`bg-[var(--bgBlackOpacity)] px-3 text-black gap-2 opacity-[0.56] ${isDetail && !isEdit ? '' : 'pointer-events-none'}`}
            onClick={setCheckUpdateVersion}
            hidden={!(isDetail && !isEdit)}
          >
            <UploadSimple size={20} />
            <span className='whitespace-nowrap'>Nâng cấp phiên bản mới</span>
          </ButtonCommon>

          <Space size='small' align='center' className='text-sm' hidden={!(isDetail && !isEdit)}>
            <Switch
              checked={isActive && !checkInactive}
              disabled={isLoading || !isDetail || checkInactive}
              onChange={onChange}
              className={`h-6 ${isDetail && !isEdit ? '' : ' cursor-not-allowed pointer-events-none '}`}
            />
            <p>Kích hoạt phiên bản</p>
          </Space>
          {!isDetail ? (
            <Space size='small' align='center' className='text-sm'>
              <Circle size={12} color='var(--primaryColor500)' weight='fill' />
              <p>Đang tạo sản phẩm mới</p>
            </Space>
          ) : (
            <>
              {checkUpdate && (
                <Space size='small' align='center' className='text-sm'>
                  <Circle size={12} color='var(--sematicWarningColor)' weight='fill' />
                  <p>Đang tạo phiên bản mới</p>
                </Space>
              )}
            </>
          )}
        </Space>
      }
      right={
        <>
          {!checkInactive && (
            <Col>
              {isDetail ? (
                <>
                  {!isEdit ? (
                    <Space size='middle' align='center'>
                      <ButtonCommon
                        color='basic'
                        fullWidth
                        radius='rounded'
                        size='md'
                        className='bg-[var(--bgRed50)] px-3 gap-2'
                        onClick={onInactive}
                      >
                        <div className='w-5 h-5'>
                          <XCircle size={20} color='var(--sematicErrorColor500)' weight='bold' />
                        </div>
                        <span className='whitespace-nowrap text-[var(--sematicErrorColor500)]'>
                          Ngừng kinh doanh sản phẩm
                        </span>
                      </ButtonCommon>
                    </Space>
                  ) : (
                    <Space size='middle' align='center'>
                      <ButtonCommon
                        color='basic'
                        fullWidth
                        radius='rounded'
                        size='md'
                        className='bg-white px-0 text-black'
                        onClick={onCancel}
                      >
                        Hủy
                      </ButtonCommon>
                      <ButtonCommon
                        color='basic'
                        fullWidth
                        radius='rounded'
                        size='md'
                        className='bg-[var(--bgBlackOpacity)] px-3 text-black gap-2'
                        onClick={onSaveDraft}
                      >
                        <DoneRoundedIcon style={{ fontSize: '20px' }} />
                        <span className='whitespace-nowrap'>Lưu bản nháp</span>
                      </ButtonCommon>
                      <ButtonCommon
                        color='basic'
                        fullWidth
                        radius='rounded'
                        size='md'
                        className='bg-[var(--primaryColor500)] px-3 gap-2'
                        onClick={onPublish}
                      >
                        <div className='w-5 h-5'>
                          <GlobeHemisphereEast size={20} />
                        </div>
                        <span className='whitespace-nowrap text-white'>Công khai</span>
                      </ButtonCommon>
                    </Space>
                  )}
                </>
              ) : (
                <Space size='middle' align='center'>
                  <ButtonCommon
                    color='basic'
                    fullWidth
                    radius='rounded'
                    size='md'
                    className='bg-white px-0 text-black'
                    onClick={onCancelCick}
                  >
                    Hủy
                  </ButtonCommon>
                  <ButtonCommon
                    color='basic'
                    fullWidth
                    radius='rounded'
                    size='md'
                    className='bg-[var(--bgBlackOpacity)] px-3 text-black gap-2'
                    onClick={onSaveDraft}
                  >
                    <DoneRoundedIcon style={{ fontSize: '20px' }} />
                    <span className='whitespace-nowrap'>Lưu bản nháp</span>
                  </ButtonCommon>
                  <ButtonCommon
                    color='basic'
                    fullWidth
                    radius='rounded'
                    size='md'
                    className='bg-[var(--primaryColor500)] px-3 gap-2'
                    onClick={onPublish}
                  >
                    <div className='w-5 h-5'>
                      <GlobeHemisphereEast size={20} />
                    </div>
                    <span className='whitespace-nowrap text-white'>Công khai</span>
                  </ButtonCommon>
                </Space>
              )}
            </Col>
          )}
          <ConfirmationModal
            isOpen={isOpen}
            onCancel={onClose}
            onConfirm={() => onCancel && onCancel()}
            title={'Bạn muốn hủy tạo sản phẩm?'}
            subtitle={'Nếu có hãy chọn vào nút đồng ý. Tất cả thao tác của bạn sẽ không được hoàn tác'}
            icon='delete'
          />
          <ReplaceVersionModal
            isOpen={isOpenReplaceVersion}
            onCancel={() => setIsOpenReplaceVersion(false)}
            // onConfirm={() => onReplaceVersion && onReplaceVersion()}
            versions={(listVersion || []).filter((item) => item.version !== version) || []}
            onConfirm={handleReplaceVersion}
          />
        </>
      }
    />
  );
};

export default ToolbarProduct;
